import { gql } from 'apollo-angular';

export const ADDRESS_FRAGMENT = gql`
  fragment AddressFragment on Address {
    id
    name
    streetName
    streetNr
    zipCode
    city
    country
  }
`;
